export default "__VITE_ASSET__DWQ33XkM__"